import { FEATURE_CODES } from "../../Static/FeatureMapping";

/**
 * Operations that grant access to the IOT device testing actions. A user with
 * the IOT_DEVICE_TESTING feature granted under ANY of these may use the actions.
 */
export const IOT_TESTING_OPERATIONS = ["view", "create", "update", "delete"];

/**
 * Whether the current user may see/use the IOT device testing actions
 * (View, Start Testing, Re-test, Mark Passed, Mark Failed) in the Unmapped IOT
 * Devices tab. Gated on the IOT_DEVICE_TESTING feature.
 *
 * `hasAnyPermission` returns true for RBAC v1 orgs, preserving the legacy
 * admin-only behaviour (the tab itself is already admin-gated in v1).
 *
 * @param {(featureCode: string, operations: string[]) => boolean} hasAnyPermission
 * @returns {boolean}
 */
export const canAccessIotTesting = (hasAnyPermission) =>
  hasAnyPermission(FEATURE_CODES.IOT_DEVICE_TESTING, IOT_TESTING_OPERATIONS);

/**
 * Append the testing action column only when access is allowed; otherwise omit
 * it entirely so there is no empty Action column. Never mutates the input.
 *
 * @param {Array} columns - the base (non-action) columns
 * @param {Object} actionColumn - the action column definition
 * @param {boolean} canAccess - result of canAccessIotTesting
 * @returns {Array}
 */
export const appendActionColumnIfAllowed = (columns, actionColumn, canAccess) =>
  canAccess ? [...columns, actionColumn] : [...columns];
